module.exports = __webpack_public_path__ + "static/media/ballymore.e6d7a11f.png";